import { ChangeDetectionStrategy, Component, inject, input, InputSignal, output } from '@angular/core';

import { MapFilterPermissionsService } from '@connect-services/client/services/map-filter-permissions.service';
import { CheckboxComponent, CheckboxState } from '@connect-services/src/lib/components/checkbox/checkbox.component';
import { MapFilter } from '@connect-services/src/sdk/api';
import { RessourcesModule } from '@ressources/client/ressources.module';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CheckboxComponent, RessourcesModule],
    selector: 'app-map-filter-item',
    styleUrl: './map-filter-item.component.scss',
    templateUrl: './map-filter-item.component.html',
})
export class MapFilterItemComponent {
    public readonly checkboxState: InputSignal<CheckboxState> = input.required<CheckboxState>();
    public deleteFilter = output<MapFilter>();
    public editFilter = output<MapFilter>();
    public readonly filter: InputSignal<MapFilter> = input.required<MapFilter>();
    public toggleFilterSelection = output<MapFilter>();

    protected readonly mapFilterPermissionsService = inject(MapFilterPermissionsService);

    protected deleteClicked(event: MouseEvent): void {
        event.stopPropagation();
        if (!this.mapFilterPermissionsService.canManage()) {
            return;
        }

        this.deleteFilter.emit(this.filter());
    }

    protected editClicked(event: MouseEvent): void {
        event.stopPropagation();
        if (!this.mapFilterPermissionsService.canManage()) {
            return;
        }

        this.editFilter.emit(this.filter());
    }
}
